import { getPancakeBunniesAddress } from 'utils/addressHelpers'

export const nftsBaseUrl = '/nfts'
export const pancakeBunniesAddress = getPancakeBunniesAddress()
